import { FirebaseRemoteConfigKey, GrowthbookKey } from 'root-constants'
import { Cohort } from './rootConstants'

export type TAbTestKey = FirebaseRemoteConfigKey | GrowthbookKey

export const COHORT_FIREBASE_KEYS_MAP: Partial<
  Record<Cohort, FirebaseRemoteConfigKey | FirebaseRemoteConfigKey[]>
> = {
  [Cohort.INTL_1]: FirebaseRemoteConfigKey.ABTEST_WEB_93_TESTTEST,
}

export const COHORT_GROWTHBOOK_KEYS_MAP: Partial<
  Record<Cohort, GrowthbookKey | GrowthbookKey[]>
> = {
  [Cohort.INTL_2]: [
    GrowthbookKey.ABTEST_WEB_238_GBP_PRICING,
    GrowthbookKey.ABTEST_WEB_147_START_SCREEN_COPY,
  ],
  [Cohort.INTL_2LW]: [
    GrowthbookKey.ABTEST_WEB_127_FIRST_SCREEN,
    GrowthbookKey.ABTEST_WEB_132_HALLOWEEN,
    GrowthbookKey.ABTEST_WEB_276_CHECKOUT_REDESIGN,
    GrowthbookKey.ABTEST_WEB_301_EMAIL_URGENCY,
    GrowthbookKey.ABTEST_WEB_130_BLOCK_PREPAID_CARD,
  ],
}
